import { convertToCsvFormatData, exportFile, formatDate } from 'app/helpers';

import { FilterReportDetail } from './type';

export const coverReportFilterToQuery = (filter: FilterReportDetail) => {
  let query = '';
  const queryStatus = Object.values(filter.action)
    .map((action) => {
      return `&action[]=${action}`;
    })
    .join('');

  if (filter.from_expriry_date && filter.to_expriry_date) {
    query = query.concat(
      `&from_expriry_date=${filter.from_expriry_date.toISOString()}&to_expriry_date=${filter.to_expriry_date.toISOString()}`,
    );
  }

  return query.concat(queryStatus);
};

export const getFormatedDate = (date: Date | null) =>
  date ? formatDate(date, 'yyyy-MM-dd') : date;

export const exportCsv = (header?: any[], items?: any, fileName?: string) => {
  const tableData = convertToCsvFormatData(header, items);
  exportFile(
    tableData.join('\n'),
    'text/csv',
    `${fileName}-${getFormatedDate(new Date())}-${Date.now()}.csv`,
  );
};

export const exportCSV = (data: string, fileName?: string) => {
  const url = data;
  const link = document.createElement('a');
  link.href = url;
  link.setAttribute('download', `${fileName}-${getFormatedDate(new Date())}.csv`);
  document.body.appendChild(link);
  link.click();
};
